// Destapa un elemento en las grabaciones de Clarity (UD-7 de /ux). En la app todo sale tapado (modo
// estricto + `data-clarity-mask` en el `<body>`), y una pantalla nueva nace tapada.
//
// REGLA: sólo un elemento HOJA cuyo texto sale de i18n SIN interpolar nada (ni un nombre ni un
// número). Lo destapado se destapa entero, con todo lo que tenga adentro: nunca en un contenedor.
// Quedan tapados el nombre de la agencia, la miga del cliente, los nombres de cuentas y clientes y
// todo número. Si una grabación muestra un dato de un cliente, se apaga ese día (`CLARITY_APP_PROJECT_ID`).
//
// Uso: <h1 {...CLARITY_UNMASK}>{t('clave')}</h1>
export const CLARITY_UNMASK = {'data-clarity-unmask': 'true'};
